import IUserHistoryFilter from "interfaces/IUserHistoryFilter";
import { GlobalState } from "little-state-machine";

export const updateUserHistoryFilter = (state: GlobalState, userHistoryFilter: IUserHistoryFilter) => ({
  ...state,
  userHistoryFilter
});
